<template>
    <main class="page-main">
        <Breadcrumbs>
            <template slot="li">
                <li @click="$router.go(-1)">/<span> Search Client</span></li>
                <li>/
                    <span v-if="clientId">Update Client (NIF: {{ currentClient.nif }})</span>
                    <span v-else>Register new Client</span>
                </li>
            </template>
        </Breadcrumbs>

        <div class="block">
            <div class="container">
                <div class="title center">
                    <h1>{{ clientId ? 'Update Client' : 'Register Client'}}</h1>
                </div>
            </div>
        </div>

        <!-- TODO - change string -->
        <label style="padding: 55px;">
            Accept RGPD ?
            <input type="checkbox" v-model="rgpd" id="rgpd">
        </label>

        <div class="overlay">
            <Loading :is-loading="loading"></Loading>
            <!-- Form Builder -->
            <Builder v-if="schema" ref="builder"
                :form-schema="schema"
                :service-url="serviceUrl"
                :service-headers="serviceHeaders"
                :show-html="true"
                :section-to-save="{
                    'key': 'section_client_details',
                    'field': 'form_policy'
                }"
                @getResponse="afterSave">
            </Builder>
        </div>

    </main>
</template>

<script>
import Builder from 'fl-ui-builder/src/Builder'
import Loading from '../../mixins/components/Loading'

export default {
    name: "Form",
    components: {
        Builder, Loading
    },
    data () {
        return {
            loading: true,
            schema: null,
            rgpd: false,
			clientId: this.$router.currentRoute.params.id,
            serviceUrl: process.env.SERVICE_URL + 'client/register',
            serviceHeaders: {
                'Authorization': 'Bearer ' + this.getUserData('access_token')
            },
            currentClient: [],
            brand: 'hassu' // TODO - change dynamically this
        }
    },
	mounted () {
        this.getSchema()
	},
    watch: {
        rgpd (newVal, oldVal) {
            if (newVal) {
                // enable fields
                this.changeStatusOfFields(true)
            }else{
                this.changeStatusOfFields()
            }
        }
    },
    methods: {

        // get schema
        getSchema () {
            this.api()
                .get('form/get/' + this.brand)
                .then(({data}) => {
                    if (data.status) {
                        this.schema = data.response.schema
                        this.$nextTick(() => {
                            this.getClient()
                        })
                    }
                }).catch((e) => {
                    this.loading = false
                    this.alert('There is no form available for this brand: ' + this.brand, 'error')
                })
        },

        // get client from API
        getClient () {
            if (this.clientId) {
                let sections = this.$refs.builder.$refs.formBuilder.getValues()

                this.api()
                    .get('client/search/id/' + this.clientId)
                    .then(({data}) => {

                        this.currentClient = data.response[0].client
                        for (let i in sections) {
                            for (let field in sections[i]) {
                                if (this.currentClient[field]) {
                                    sections[i][field] = this.currentClient[field]
								}

                                if (this.currentClient['user_details'] !== null) {
                                    let userDetails = JSON.parse(this.currentClient['user_details'])
                                    let deepField = field.split('.')[1]

                                    if (userDetails) {
										if (deepField)
                                        	sections[i][field] = userDetails[deepField]
                                    }
                                }
                            }
                        }

                        this.$refs.builder.$refs.formBuilder.setValues(sections)
                        this.loading = false
                        this.rgpd = true

                    }).catch((e) => {
						console.log(e)
						this.loading = false
                    })

            }else{
                this.$refs.builder.$refs.formBuilder.clearForm()

                // disable fields
                this.changeStatusOfFields()
                this.loading = false
            }
        },

        // after Form submission and save
        afterSave (response) {
            let {data} = response
            // on success
            if (data) {
                this.alert(data.response, 'success')
                if (!this.clientId) {
                    this.changeStatusOfFields(false, true)
                    this.rgpd = false
                }

            }else{
                // on error
                let {data} = response.response
                let r = data.response
                for (let i in r)
                    this.alert(r[i], 'error')
            }
        },

        // enable / disable input fields
        changeStatusOfFields (enable = false, reset = false) {
            let inputs = document.querySelectorAll('input,select')
            inputs.forEach(function(input) {
                if (input.id !== 'rgpd')
                    input.disabled = enable ? false : true
            })
            if (reset) {
                this.loading = true
                this.getSchema()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clients/Form.vue